import { Block, Link, Typography } from '@klp/design';
import { KlpFontVariant, KlpPalette } from '@klp/design/Theme';
import type { LeverandorStatistics } from '@klp/leverandor/types';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LeverandorRoutes } from '@klp/leverandor/config';
import { tildeltMegLenke } from '@forvalter/frontpage/hooks/useListFilters';
import { useHistory } from 'react-router-dom';

type LeverandorSummaryStatisticsProps = {
    statistics: LeverandorStatistics;
};

const useStyles = makeStyles(() => ({
    greenText: {
        color: KlpPalette.secondary.main,
    },
    text: {
        paddingTop: '5px',
        paddingLeft: '2px',
        fontSize: KlpFontVariant.small.fontSize,
    },
}));

export default function LeverandorSummaryStatistics({
    statistics,
}: LeverandorSummaryStatisticsProps) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    // Opens the list with «Tildelt meg» on
    const handleClick = () => {
        history.push(
            `${LeverandorRoutes.leverandorSchema()}${tildeltMegLenke}`,
        );
    };

    return (
        <Block marginBottom="bulky">
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.TildeltMeg}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>
                    <Link
                        onClick={handleClick}
                        translation="frontPage.leverandor.assignedToMe"
                    />
                </span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.UnderVurdering}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>
                    {t('frontPage.leverandor.underAssessment')}
                </span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.Fullfort}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>
                    {t('frontPage.leverandor.completed')}
                </span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>{statistics?.Avvist} </span>
                &nbsp;
                <span className={classes.text}>
                    {t('frontPage.leverandor.rejected')}
                </span>
            </Typography>
        </Block>
    );
}
